/**
 * Label for the firm-logo control. Local for the same reason as the title
 * above: `ui-strings.ts` is past the red band. Distinct wording from the
 * contact headshot in the header card, since the two are different fields on
 * different S3 prefixes and an investor must be able to tell them apart.
 */
export const INVESTOR_FIRM_LOGO_LABEL = 'Firm Logo';

/**
 * Caption on the header avatar's upload control. Names the field rather than
 * just the action: the header sits beside the FUND name, so an unlabelled
 * avatar there reads as the firm's mark when it is actually the contact's
 * headshot - and the firm's real logo is a separate control further down.
 * The two write to different S3 prefixes and must not be confused.
 */
export const INVESTOR_CONTACT_PHOTO_CAPTION = 'Upload Contact Photo';

/** Colleague contact field limits; mirror the Backend `ColleagueContactDto` `MaxLength`s. */
export const COLLEAGUE_NAME_MAX_LENGTH = 200;
export const COLLEAGUE_EMAIL_MAX_LENGTH = 320;

/** Label over the contact photo upload, matching the firm logo's beside it. */
export const INVESTOR_CONTACT_PHOTO_LABEL = 'Contact Photo';

/** Investor profile header copy (MYN-217, profile-redesign FR-174). */
export const INVESTOR_PROFILE_HERO_STRINGS = {
  ACTIVELY_DEPLOYING: 'Actively deploying',
  TICKET_SIZE: 'Ticket size',
  STAGES: 'Stages',
  LEAD_OR_FOLLOW: 'Lead or follow',
  MIN_REVENUE: 'Minimum revenue',
} as const;

/** Investor profile card copy, worded as in the client-approved mockup (MYN-217, FR-175). */
export const INVESTOR_CARD_STRINGS = {
  ABOUT: 'About',
  WHAT_WE_INVEST_IN: 'What we invest in',
  FOUNDER_PREFERENCES: 'Founder preferences',
  LOCATION: 'Location',
  GEOGRAPHIES: 'Preferred geographies',
  CONTACT: 'Contact',
  TITLE: 'Title',
  INVESTOR_TYPE: 'Investor type',
  EMAIL: 'Email',
  PHONE: 'Phone',
  WEBSITE: 'Website',
  LINKEDIN: 'LinkedIn',
  INDUSTRIES: 'Industries',
  STAGES: 'Stages',
  RECURRING_REVENUE: 'Recurring revenue',
  OTHER_CRITERIA: 'Other criteria',
  MARKET: 'Market',
  MARKET_MODELS_LABEL: 'Market model preferences',
  FEMALE_LED: 'Female-led startups',
  UNDERREPRESENTED: 'Underrepresented founders',
  UNDERREPRESENTED_GROUPS: 'Underrepresented groups',
  COMMUNITY: 'Community',
  OFFICE_HOURS: 'Office hours',
  FOUNDER_FUNDER_EVENTS: 'Founder-funder events',
  ADDRESS: 'Address',
  POSTAL_CODE: 'Postal code',
  CITY: 'City',
  STATE: 'State',
  COUNTRY: 'Country',
  GEOGRAPHIES_EMPTY:
    'None added yet. Add the regions or countries you invest in so matching can use them.',
  ADD_GEOGRAPHY: '+ Add Geography',
  // Colleague contacts by industry (MYN-202), as a card in the MYN-217 layout.
  COLLEAGUES: 'Colleague contacts',
  COLLEAGUES_EMPTY:
    'No colleague contacts yet. Name a colleague for each industry so the right person is known.',
} as const;
